import client from "api/client";

export default {
  all: () => client.get("/categories"),
};
